import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  side: {
    background: '#F8F8F8',
    gap: {
      padding: '10px 15px',
      marginBottom: '8px'
    }
  },
  line: {
    background: 'linear-gradient(90deg, #F3F4F6 0%, #E5E7EB 100%)',
    height: '24px',
    display: 'inline-block',
    clear: {
      clear: 'both'
    },
    newLine: {
      display: 'block'
    }
  },
  line2: {
    height: '21px'
  }
};

const SkeletonFlightRecommender = (props) => {
  const [className, style] = useStyles(props);
  const {
    itemsToShow = 3,
    contentSettings = { 'cmp-styles': { 'border-radius': '0px 5px 5px 0px' } }
  } = props;
  const { side, line, line2 } = styles;
  return (
    <Box className={className} style={style} dataTestId="SkeletonFlightRecommender">
      {Array(itemsToShow)
        .fill('')
        .map((i, index) => {
          return (
            <Row style={{ ...side, ...side.gap }} {...contentSettings} key={index}>
              {/* <Col style={{ ...side, ...side.gap }} {...contentSettings}>
                <Row> */}
              <Col xs={8}>
                <Box style={{ ...line, width: '100%', marginBottom: '5px' }}></Box>
                <Box style={{ ...line, ...line.newLine, width: '80%' }}></Box>
              </Col>
              <Col xs={4} style={{ alignSelf: 'end', paddingLeft: '15px' }}>
                <Box
                  style={{
                    ...line,
                    ...line2,
                    ...line.newLine,
                    width: '80%',
                    marginBottom: '3px'
                  }}
                ></Box>
                <Box style={{ ...line, ...line2, ...line.newLine, width: '100%' }}></Box>
                {/* </Col>
                </Row> */}
              </Col>
            </Row>
          );
        })}
    </Box>
  );
};

SkeletonFlightRecommender.componentName = 'SkeletonFlightRecommender';

export default SkeletonFlightRecommender;
